/**
 * @file        src/api/paymentReconciliation.js
 * @description Payment Reconciliation API calls (/api/payment-reconciliation) —
 *              the money-discrepancy queue booking_backend writes when the
 *              gateway captured money we did not deliver on, or when a
 *              confirmed booking never collected its wallet leg.
 *
 *              Read-mostly. The only write records the SETTLEMENT — nothing
 *              here moves money: no gateway refund API is integrated, so a
 *              refund is made in the Easebuzz dashboard and recorded back here.
 * @author      Kinetika Labs
 * @created     2026-09-22
 * @changelog
 *   - 2026-09-22 Claude — Initial (Account Management → Payment Reconciliation).
 */
import { get, patch } from './client';

/**
 * Paginated + filterable queue, OLDEST FIRST (it is a worklist of money owed).
 * params: { page, pageSize, direction, flow, status, reason, brand, search, from, to }.
 * Response shape: { data: { rows, total, page, pageSize } }.
 */
export const listPaymentReconciliation = (params) => get('/payment-reconciliation', { params });

/** KPI strip. Takes the SAME filters as the list so the cards match the table. */
export const paymentReconciliationTotals = (params) => get('/payment-reconciliation/totals', { params });

/** The reason strings actually present, so the filter never offers a dead option. */
export const paymentReconciliationReasons = () => get('/payment-reconciliation/reasons');

/**
 * One item, including the raw `gateway_post` callback body. Deliberately NOT in
 * the list payload: it is a whole gateway POST per row, and it is only ever
 * read one item at a time in the settle panel.
 */
export const getPaymentReconciliation = (id) => get(`/payment-reconciliation/${id}`);

/**
 * Record the settlement. `status` is open | refunded | resolved.
 * `refunded` ASSERTS MONEY MOVED and the API re-verifies the admin's password,
 * so `body.password` is mandatory for that one and ignored for the others.
 */
export const settlePaymentReconciliation = (id, body) => patch(`/payment-reconciliation/${id}`, body);
